import { handleError } from "../../../util/errors";
import apiBase from "../../api";
import {
  INTERVEND_QUEUE_METRICS,
  INTERVEND_QUEUE_SUMMARY,
  INTERVEND_QUEUE_JOBS,
  INTERVEND_QUEUE_TRUNCATE,
} from "../../urls";

class IntervendQueueService {
  getQueueMetrics = async () => {
    try {
      const response = await apiBase.get(INTERVEND_QUEUE_METRICS);
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  getQueueSummary = async () => {
    try {
      const response = await apiBase.get(INTERVEND_QUEUE_SUMMARY);
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  getQueueJobs = async (state = "waiting", page = 1, perPage = 20) => {
    try {
      const response = await apiBase.get(INTERVEND_QUEUE_JOBS(state, page, perPage));
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  truncateQueue = async (state = "all") => {
    try {
      const response = await apiBase.post(INTERVEND_QUEUE_TRUNCATE, { state });
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };
}

export default new IntervendQueueService();

